export default __webpack_public_path__ + "static/media/smooth.d13dd474.PNG";